import { PDFDocument, degrees } from "pdf-lib";

export async function exportOrganizedPdf(sourceBytes, pages, onProgress = () => {}) {
  if (!pages.length) throw new Error("Choose at least one page to export.");

  const source = await PDFDocument.load(sourceBytes.slice(), { updateMetadata: false });
  const output = await PDFDocument.create();
  output.setCreator("smallpdf.app");
  output.setProducer("smallpdf.app Organize PDF");
  const copied = await output.copyPages(source, pages.map(page => page.sourceIndex));

  copied.forEach((page, index) => {
    page.setRotation(degrees(pages[index].rotation));
    output.addPage(page);
    onProgress(index + 1, copied.length);
  });

  return output.save({ useObjectStreams: true });
}
